import { Grid, IconButton, TextField, Tooltip } from "@mui/material";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getFullName,
  getLocalValue,
  LoacalVariables,
  Method,
  updateMainHeader,
} from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { Header } from "../../../Components/Header/Header";
import WSStaticDataGrid from "../../../Components/StaticDataGrid/StaticDataGrid";
import { GridColDef } from "@mui/x-data-grid";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import ConfirmationPopup, {
  IMethodAction,
} from "../../../Components/Confirmation/Confirmation";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";
import { openPopUp } from "../../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../../Components/Dialog/WSCommonDialog";
import { useForm } from "react-hook-form";
import ReasonComp from "./ReasonComp";
import http from "../../../commonFunctions/httpClient";
import WSDataGridNew from "../../../Components/DataGrid/WSDataGridNew";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
export const WithdrawalList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [walletListData, setWalletListData] = useState<any>([
    { id: "123", walletOwner: "abc" },
  ]);
  const dispatch = useDispatch();
  const { control, register, handleSubmit, setValue, reset } = useForm();
  // AllPermissions.getInstance();
  //const { add,edit,remove, view} =AllPermissions.getCallPermission;
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [action, setAction] = useState<IMethodAction>("DELETE");
  const [apiUrl, setApiUrl] = useState<any>(null);
  const [bodyData, setBodyData] = useState<any>(null);
  const [reason, setReason] = useState("");

  const { showMessage } = useSnackbar();


  const { add, edit, remove } = getPermissions("withdrawals"); // role permissions for this page

  const filters = ["All Records"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const [productSource, setProductSource] = useState<any>({
    url: "WithdrawalRequest/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [
      
    ],
  });

  const handleFilter = (value: any) => {
    let soureFilter: any = {
      url: "WithdrawalRequest/search",
      page: 1,
      pageSize: 10,
      filter: [],
      sort: [
        {
          field: "UpdatedAt",
          direction: "desc",
        },
      ],
    };
    switch (value) {
      case "In Stock":
        soureFilter.filter = [
          {
            field: "name",
            operator: "eq",
            value: "In Stock",
          },
        ];
        break;
    }
    //  setProductSource({ ...soureFilter });
  };
  useEffect(() => {
    updateMainHeader("Withdrawal  ");
  });

  breadCrumbsStore.updateBreadCrumbs([
    { "Withdrawal List": "/withdrawal/list" },
  ]);
  const source = {
    url: "WithdrawalRequest/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };
  const handleData = async (data: any) => {
    try {
      const response: any = await http.post(
        `WithdrawalRequest/reject/${data?.id}?note=${data?.reason}`,
        {}
      );
      if (response) {
        //&& response?.success) {
        dispatch(resetDataComponent("withdrawalListGrid"));
        showMessage(response?.message, "success");
      } else {
        showMessage(response || "Something went wrong", "error");
      }
    } catch (e) {}
  };

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, rows: any) => {
    if (action === "Approve") {
      setAction("POST");
      setApiUrl(
        `WithdrawalRequest/approve/${rows?.id}?approvedBy=${getLocalValue(
          LoacalVariables.UserId
        )}`
      );
      setSelectedId(null); // Set the ID of the row to be deleted
      setPopupOpen(true);
      setBodyData({});
    } else if (action === "Reject") {
      const metadata: IMetaData = {
        title: "Meeting",
        hideActions: false,
        content: (props: any, row: any) => (
          <ReasonComp
            control={control}
            id={"reasonid"}
            register={register}
            reset={reset}
            setValue={setValue}
            urlId={rows?.id}
            {...props}
          />
        ),
        actions: [
          {
            label: "Cancel",
            className: "ws-cancel",
            type: "button",
          },
          {
            label: "submit",
            onClick: handleData,
            type: "submit",
            autoFocus: true,
          },
        ],
        isDragable: true,
      };

      openPopUp(metadata, handleData, "40rem");

      // setAction('POST')
      // const comp = {
      //     component: (
      //         <TextField
      //             fullWidth
      //             label="Reason"
      //             value={reason}
      //             onChange={(e) => setReason(e.target.value)}
      //         />
      //     ),
      //     getComponentData: () => ({ reason }),
      //     onConfirm: (res: any) => {
      //         console.log('API Response:', res);
      //     }
      // };

      // setApiUrl(`WithdrawalRequest/reject/id?=${row?.id}approvedBy?=${getLocalValue(LoacalVariables.UserId)}`)
      // setSelectedId(null); // Set the ID of the row to be deleted
      // setPopupOpen(true)
      // setBodyData({})
    }
  };

  // const columns: GridColDef[] = [
  //     {
  //         field: 'walletOwner',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'name',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'test',
  //         headerName: 'First name',
  //         width: 150,
  //         sortable: true

  //     },
  //     {
  //         field: 'actions',
  //         headerName: 'Actions',
  //         width: 120,
  //         sortable: false,
  //         filterable: false,
  //         renderCell: (params) => (
  //             <>
  //                 <Tooltip title="Edit">
  //                     <IconButton >
  //                         <EditIcon fontSize="small" />
  //                     </IconButton>
  //                 </Tooltip>
  //                 <Tooltip title="Delete">
  //                     <IconButton >
  //                         <DeleteIcon fontSize="small" />
  //                     </IconButton>
  //                 </Tooltip>
  //             </>
  //         )
  //     }

  // ];
  const columns: IColumns[] = [
    {
      header: "Doctor",
      fieldName: "name",
      type: "default",
    },
    {
      header: "Amount",
      fieldName: "amount",
      tooltip: true,
      //  isHide: isMobile,
      type: "default",
    },
    {
      header: "Requested On",
      fieldName: "requestedAt",
      //  isHide: isMobile,
      type: "date",
    },
    //  {
    //             header: "Refference",
    //             fieldName: "referenceId",
    //             tooltip: true,
    //             //  isHide: isMobile,
    //             type: "default",
    //         },
    {
      header: "Status",
      fieldName: "status",
      //    isHide: isMobile,
      type: "status",
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit && "Approve", edit && "Reject"].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
      hideSelectedActions: {
        fieldToHide: [
          {
            field: "status",
            hideValue: ["Rejected"],
            hideActions: ["Reject", "Approve"],
          },
          {
            field: "status",
            hideValue: ["Completed"],
            hideActions: ["Reject", "Approve"],
          },
        ],
      },
    },
  ];

  const transFormData = (data: any) => {
    if (data) {
      data.map((item: any) => {
        item.locked = item?.isLocked ? "Yes" : "No";
        // item.phoneNumber = `${item?.customer?.phoneNumber}`;
        // item.doctorName = `${item?.doctor?.user?.name}`;
      });
      return data;
    }
  };
  const handleConfirm = (response: any) => {
    dispatch(resetDataComponent("withdrawalListGrid"));
    showMessage(response?.message, response?.success ? "success" : "error");
  };
  return (
    <Grid p={3}>
      {/* <Header type="simple" isDivider={true} title="Wallets" id={'walletHeader'} headerSx={{ paddingBottom: 1, backgroundColor: '#499426', color: '#fff', }} /> */}
      {/* <Grid container spacing={2}>

                <Grid item xs={12}>
                    <WSDataGrid
                        id="withdrawalListGrid"
                        title="Withdrawal"
                        columns={columns}
                        source={source}
                        transFormData={transFormData}
                        // searchBox={{ fieldName: 'firstName,company,lastName,mobile' }}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />

                    <WSStaticDataGrid
                        id="walletGrid"
                        title="Wallets"
                        columns={columns}
                        data={walletListData}

                    />
                </Grid>
                {apiUrl !== null && <ConfirmationPopup
                    apiUrl={apiUrl}
                    id={selectedId!}
                    confirmMessage="Are you sure you want to continue?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={handleConfirm}
                    type={action}
                    bodyData={bodyData}
                />}
            </Grid> */}

      <Grid container spacing={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup
            options={filters}
            selected={selectedFilter}
            onChange={(value) => {
              setSelectedFilter(value);
              handleFilter(value);
            }}
          />
        </Grid>

        <Grid item xs={12}>
          {productSource && (
            <WSDataGridNew
              id="withdrawalListGrid"
              title="Withdrawal"
              columns={columns}
              source={productSource}
              transFormData={transFormData}
              searchBox={{ fieldName: "name" }}
              gridHeaderSx={{
                backgroundColor: "whitesmoke",
                border: "1px solid whitesmoke",
              }}
            />
          )}
          {apiUrl !== null && (
            <ConfirmationPopup
              apiUrl={apiUrl}
              id={selectedId!}
              confirmMessage="Are you sure you want to continue?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleConfirm}
              type={action}
              bodyData={bodyData}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
